<template>
  <div ref="container" class="s-gallery-slick">
    <div class="page-container">
      <div v-if="percentage" class="s-gallery-slick__progress-bar">
        <ProgressBar :percentage="percentage" />
      </div>

      <SlickCarousel
        ref="slick"
        :key="'key-' + slickKey"
        class="s-gallery-slick__slick"
        :options="slickOptions"
        @init="onInit"
        @beforechange="onBeforeChange">
        <div
          v-for="(item, index) in records"
          :key="index"
          class="s-gallery-slick__slide item">
          <a
            class="s-gallery-slick__image"
            data-fancybox="gallery"
            :href="item.image?.url">
            <LazyImage
              v-if="item.thumbnail"
              :image="item.thumbnail"
              class="object-fit-cover" />

            <i class="icon-zoom"></i>
          </a>
        </div>
      </SlickCarousel>
    </div>
  </div>
</template>

<script>
import * as lib from '../../lib/lib'
import ProgressBar from './../components/common/ProgressBar.vue'
import SlickCarousel from '../components/common/SlickCarousel.vue'
import { Fancybox } from '@fancyapps/ui'
import LazyImage from './../components/common/LazyImage.vue'

export default {
  components: { ProgressBar, LazyImage, SlickCarousel },
  data() {
    return {
      percentage: 0,
      records: [],
      slickKey: 0,
      slickOptions: {
        infinite: false,
        autoplay: false,
        arrows: true,
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: false,
        variableWidth: true,
        responsive: [
          {
            breakpoint: 992,
            settings: { slidesToShow: 2, variableWidth: false },
          },
          {
            breakpoint: 768,
            settings: { slidesToShow: 1, variableWidth: false },
          },
        ],
      },
      fancyboxOptions: {
        Toolbar: {
          display: {
            left: [],
            middle: [],
            right: ['close'],
          },
        },
      },
    }
  },
  mounted() {
    const { records } = lib.getData('galleryData')
    this.records = records
    Fancybox.bind(this.$refs.container, '[data-fancybox]', this.fancyboxOptions)
  },
  methods: {
    onInit(event, slick) {
      this.percentage = lib.getSlickProgressBarPercentage(slick)
    },
    onBeforeChange(event, slick) {
      setTimeout(() => {
        this.percentage = lib.getSlickProgressBarPercentage(slick)
      }, 100)
    },
  },
}
</script>
